import hasPermission from "@/directive/permissionButton/hasPermission";

export default {
  inserted(el, binding, vNode) {
    let currentRoute = vNode.context.$route;
    if (!hasPermission.hasPermission(currentRoute, binding.value)) {
      if (el.parentNode != null) {
        el.parentNode.removeChild(el);
      }
    }
  },
};
